import { colorsPalettes } from "@similarweb/styles";
import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import {
    StyledDot,
    StyledIconButton,
    StyledTagLabel,
} from "app/pages/sales-intelligence/modules/lists/components/cells/TagCell/styles";
import { getTagColor } from "app/pages/sales-intelligence/modules/lists/components/cells/TagCell/utils";
import type { TagColumnValue, TagColumnValueResponse } from "app/pages/sales-intelligence/modules/lists/types/columns";

export const TagOption = ({
    tag,
    selectedValue,
    handleSelect,
    handleEditClick,
    handleDeleteClick,
}: {
    tag: TagColumnValueResponse;
    selectedValue: TagColumnValue | null;
    handleSelect: (tag: TagColumnValueResponse) => void;
    handleEditClick: (event: React.MouseEvent<HTMLButtonElement>, tag: TagColumnValueResponse) => void;
    handleDeleteClick: (event: React.MouseEvent<HTMLButtonElement>, tag: TagColumnValueResponse) => void;
}) => {
    return (
        <Combobox.Option
            key={tag.Id}
            value={tag}
            textValue={tag.Title}
            isSelected={selectedValue?.id === tag.Id}
            onClick={() => handleSelect(tag)}
        >
            <Flex
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                gap="4px"
            >
                <Flex
                    alignItems="center"
                    gap="8px"
                >
                    <StyledDot color={getTagColor(tag)} />
                    <StyledTagLabel>{tag.Title}</StyledTagLabel>
                </Flex>
                <Flex
                    alignItems="center"
                    gap="4px"
                >
                    <StyledIconButton
                        type="flat"
                        iconName="edit-icon-fill"
                        iconSize="13px"
                        data-automation={`lists-tag-edit-${tag.Id}`}
                        color={colorsPalettes.carbon[250]}
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleEditClick(event, tag)}
                    />
                    <StyledIconButton
                        type="flat"
                        iconName="delete"
                        iconSize="13px"
                        data-automation={`lists-tag-remove-${tag.Id}`}
                        color={colorsPalettes.carbon[250]}
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleDeleteClick(event, tag)}
                    />
                </Flex>
            </Flex>
        </Combobox.Option>
    );
};
